import { InjectionToken } from '@angular/core';
import { BathroomHbmService } from '../services/configurators-2d/applications/bathroom-hbm.service';

export const BA_HBM_SERVICE = new InjectionToken(typeof BathroomHbmService);

export const bathroomHbmProviders = [
  {
    provide: BA_HBM_SERVICE,
    useClass: BathroomHbmService,
  },
];
